"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  chr: {
    roleName: '角色名称',
    officeCode: '机构简称',
    leaseDate: '租约日期',
    leaseTermLength: '租期长度',
    rfRate: '租金/运费率',
    commissionRate: '佣金率',
    actDelTime: '交船期',
    actRedTime: '还船期',
    dlDate: '交船期/受载期',
    returnTime: '还船时间',
    broker: '经纪人',
    isObo: '条款是否背靠背,如否请说明',
    depReq: '离港证开具要求',
    otherRemark: '其他交接事项',
    planeVoyageStatus: '启动中的航次不能删除',
    cargoDesc: '货物描述',
    addPort: '新增港口',
    homeCurrency: '本位币',
    hasContractInfoError: '存在有合同信息的经营公司与测算不一致',
    currentTitle: '当期票模式',
    rollTitle: '滚动账单模式',
    titlePlane: '航次计划信息',
    toArapMessage: '应收应付的状态为是，不可以废除',
    messageStatus: '测算未审核,无法生成航次计划',
    messAlready: '此航次计划已经启动过了',
    InitiatingVoyage: '启动航次',
    voyageGusuan: '航次估算',
    messageVoyage: '只能选择一条数据,请重新选择',
    addVoyagePlan: '生成航次计划',
    specialFouceCargo: '是否有超过船吊负荷的重大件',
    shipCraneDis: '是否船吊作业',
    useAgent: '是否有推荐代理',
    speedRequest: '航速要求',
    charterAgent: '是否租家指定代理(如否,推荐代理)',
    grabBucket: '是否使用船上抓斗',
    portConditions: '业务提前询港，港口情况（附询港邮件）',
    stateroomRequest: '备舱要求',
    fuelConsumption: '航速油耗要求',
    voyageIntention: '有无航次意向',
    ballastDirection: '空放方向',
    needAgent: '是否安排船东保护代理',
    pniGaugingInspectio: '装卸港是否聘请PNI水尺检验',
    specialTermsCharter: '额外承诺的特别事项',
    urgentDispatch: '合同订立后紧急事项',
    specialCabinArrangements: '备舱要求，特殊备舱安排',
    brokerContact: '经纪人/租家联系方式',
    oilPlan: '加油计划',
    oilPlanCopy: '是否有我司加油计划',
    noBL: '是否无单放货',
    voyageHandover: '航次交接',
    absrtact: '摘要',
    signatureTime: '签署日期',
    vesselNameOne: '船舶',
    contractList: '合同列表',
    portDisbursementSource: '港使费来源',
    otherFee: '其他费用',
    supervisionFee: '监装费',
    eindingFee: '绑扎费',
    loadDischargeFee: '装卸货费',
    portDisbursement: '港使费',
    cargoManagementDays: '货管时间（天）',
    tankWashDays: '洗舱时间(天)',
    berthDays: '等泊及其他时间(天)',
    dischargeDay: '卸货时间(天)',
    loadDay: '装卸(天)',
    lsDistance: 'LS距离',
    distance: '距离',
    portName: '港口',
    portPurpose: '港口操作',
    planePortList: '挂港列表',
    createrUser: '创建者',
    manageCompany: '经营公司',
    addRepair: '新增修船航次',
    addNewAir: '新增空放航次',
    document: '单证',
    operateBy: '操作人',
    voyageCurrency: '航次币种',
    estEndDate: '预计结束时间',
    estBeginDate: '预计开始时间',
    vesselSource: '船舶性质',
    fuelPricing: '燃油计价',
    additionalOperationDay: '附加操作时间(天)',
    additionalSailingDay: '附加航行时间(天)',
    vesselStability: '船舶稳性',
    vesselDisplacement: '船舶排水量',
    totalProfit: '总利润',
    dailyProfitLevel: '日盈利水平',
    totalCost: '总成本',
    heavyLoadSpeed: '重载速度',
    sailingSpee: '速度',
    opeRateDays: '装卸天',
    sailingDay: '航行天',
    association: '关联',
    lastPort: '最后卸港',
    firstPort: '第一装港',
    checkStatus: '复核状态',
    operationManagement: '经营管理',
    shipManagementContract: '船舶管理合同',
    escrowContract: '代管船合同',
    escrowContractManager: '代管船合同管理',
    contractInfo: '合同信息',
    contractName: '合同名称',
    contNo: '合同编号',
    contType: '合同类型',
    contStatus: '合同状态',
    contractDate: '合同时间',
    contractTime: '合同日期',
    endDate: '终止时间',
    effectDate: '生效时间',
    shipTeam: '船型团队',
    effectDescription: '生效说明',
    modelContract: '合同范本',
    contractCurrency: '合同币种',
    isMajorContract: '是否重大合同',
    handledBy: '经办人',
    lastUpdatedBy: '最后修改人',
    handlingTime: '经办时间',
    updateTime: '修改时间',
    shipInfo: '船舶信息',
    shipName: '船名',
    voyageNo: '航次号',
    cargoInSummer: '夏季货物载重吨',
    fullLoadDraft: '满载吃水',
    shipDescription: '船舶描述',
    ourContractInfo: '我方签约信息',
    signatorySub: '签约主体',
    signatory: '签约人',
    hasProvideContract: '是否为合同提供担保',
    shipOwner: '船东/实际承运人',
    propCompany: '控股公司',
    MgtFeeAndTime: '管理费和时间',
    otherProvisions: '其他条款',
    contractAnnex: '合同附件',
    contractForm: '合同审批单',
    contractFiling: '合同归档',
    updAtt: '上传附件',
    check: '查看',
    attName: '附件名称',
    uploadTime: '上传时间',
    uploader: '上传人',
    uploadDep: '上传部门',
    historyAppComments: '历史审批意见',
    appPhase: '审批环节',
    appTime: '审批时间',
    approver: '审批人',
    corporateName: '公司名称',
    appDep: '审批部门',
    appAction: '审批操作',
    appComments: '审批意见',
    agree: '同意',
    reject: '驳回',
    action: '操作',
    nowApprover: '当前审批人',
    nowAppDep: '当前审批部门',
    handingOptions: '处理意见',
    appProcess: '审批流程',
    isSendLegalSystem: '是否发送法务系统',
    contFilingDate: '合同归档日期',
    contArchiver: '合同归档人',
    contNumber: '合同总份数',
    contFilingDep: '合同归档部门',
    contFilingNumber: '合同归档份数',
    otherDep: '其他原件持有部门',
    heldNumber: '持有份数',
    remark: '备注',
    tips: '提示：\n' + '1.合同审核状态为已审时，合同才允许归档;\n' + '\n' + '2.合同归档确认后所有合同信息将锁定不能再调整',
    // 提单管理
    BillMgmt: '提单管理',
    searchFilter: '可查询提单号',
    searchFilterNo: '可查询提单号,合同号',
    searchFilterTwo: '可查询大副收据编号',
    searchFilterThree: '可查询提单号、大副收据编号',
    BLTracking: '提单跟踪',
    BLTemplate: '提单模板管理',
    BLTemplateEdit: '提单模板编辑',
    vesselName: '船名',
    // voyageNo: '航次',
    carrierName: '承运人',
    sendAgentFlag: '是否已发送代理',
    creator: '创建人',
    createTime: '创建时间',
    createTimeFrom: '创建时间从',
    createTimeTo: '创建时间到',
    vesselCode: '船舶编号',
    vesselEnName: '船舶名称（英）',
    vesselCnName: '船舶名称（中）',
    ripCode: ' 相关方代码',
    nameCn: '中文名',
    nameEn: '英文名',
    sendProxy: '发送代理',
    BLList: '提单列表',
    CMRList: '大副收据列表',
    mainInformation: '主信息',
    basicInformation: '基本信息',
    sendAgentDate: '发送时间',
    signature: '签名',
    lastModifyBy: '修改人',
    lastModifyTime: '修改时间',
    polInformation: '装港信息',
    podInformation: '卸港信息',
    soNo: '大副收据编号',
    polName: '装港',
    podName: '卸港',
    issuePlace: '签发地点',
    contractNo: '合同号',
    chartererName: '租家',
    chartererName1: '租家名称',
    checkContract: '查看合同',
    shippingAgentName: '船代',
    shippingAgentMail: '船代邮箱',
    email: '邮箱',
    ladMessage: '提单信息',
    copyAdd: '拷贝新增',
    copyNewAdd: '拷贝新增大副收据',
    look: '查看',
    lodNo: '提单号',
    code: '关联大副收据编号',
    twoInfo: '大副收据信息',
    copyLod: '拷贝新增提单',
    daCode: '大副收据编号',
    relactNo: '关联提单号',
    forwarder: '货代界面',
    templateSearch: '提单模板查询',
    issueType: '电放/正本',
    blFormat: '提单格式',
    sure: '确定',
    cancel: '取消',
    templateDetail: '提单明细编辑',
    submit: '提交',
    upload: '保函已签字上传',
    newUpload: '提单已签字上传',
    placeholderlodNo: '提单号前缀',
    shipper: '发货人',
    shipperDesc: '发货人描述',
    consignee: '收货人',
    consigneeDesc: '收货人描述',
    notify: '通知人',
    notifyDesc: '通知人描述',
    marks: '唛头',
    noOfPackage: '件数',
    grossWeight: '重量',
    goodsCube: '体积',
    goodsDesc: '货描',
    preloadingDesc: '装前检验批注',
    deckDesc: '甲板货批注',
    totalDesc: '件数英文描述',
    issueDate: '签发时间',
    noOfOriginalBl: '正本提单份数',
    otherInfo: '其他信息',
    approvalStatus: '审核状态',
    approvalStatus2: '审批状态',
    invalidFlag: '是否作废',
    releaseFlag: '放单状态',
    releaseTime: '放单时间',
    retakeFlag: '提单回收',
    retakeTime2: '提单回收时间',
    retakeFlagStatus: '提单回收状态',
    retakeTime: '回收时间',
    associateone: '关联大副收据',
    infomation: '附件信息',
    messageNumber: '大副收据编号',
    errorMessage: '请重试',
    errorBlno: '该提单号已存在，不能保存',
    message: '收货人一栏出现 order 字样，是否继续保存？',
    grossWeightValid: '所填写毛重不一致',
    goodsCubeValid: '所填写体积不一致',
    noOfPackageValid: '所填写件数不一致',
    descError: '当前提单与[大副收据编号]的[字段标签名]不一致，是否继续保存？',
    timeError: '当前提单的签发日期与[大副收据编号]的装船日期不一致，是否继续保存？',
    loadDateCheckMsg: '当前提单的签发日期与大副收据[{soNo}]的装船日期不一致，是否继续保存？',
    descCheckMsg: '当前提单与大副收据[{soNo}]的[{desc}]不一致，',
    keepIt: '是否继续保存？',
    // 大副收据管理
    mateManagement: '大副收据管理',
    state: '状态',
    mateDetailedEdit: '大副收据明细编辑',
    // 提单管理
    loiConfirmFlag: '是否保函',
    errorApprovalStatus: '该提单审批状态为',
    noDelete: '不能删除',
    putSingle: '放单',
    exportManifest: '导出舱单',
    exportManifestCheck: '未输入船舶、航次、装港、卸港过滤条件，无法导出。',
    recall: '提单回收',
    process: '审批流程',
    relaceblSo: '关联大副收据',
    relactContract: '关联合同号',
    isRelease: '是否放单',
    releaseMessage: '请填写放单事件',
    moreMeszsage: '请选择其中一条数据',
    exportCheck: '未查到审批通过的提单数据,无法导出舱单',
    submitApproval: '提交审批',
    cancelApproval: '取消审批',
    approval: '审批',
    viewFlow: '查看审批流',
    rejerction: '驳回货代',
    send: '发送邮件',
    guarantee: '生成保函',
    sureGuarantee: '确认保函',
    blAddDialog: '指定提单格式/装卸港',
    soAddDialog: '指定装卸港',
    cancelSureGuarantee: '取消确认保函',
    invalid: '作废',
    risk: '风险筛查',
    warningTidan: '请先保存数据',
    templadeError: '勾选提单不是同一个船名航次，不能操作',
    messageError1: '请选择要操作的组织',
    messageError2: '存在提单号已关联大副收据，不能操作',
    // 正本提单回收
    time: '时间',
    shipType: '船型',
    original: '正本提单放货',
    voyage: '航次数',
    goodsGuarantee: '保函放货',
    originalWithdrawn: '正本提单全部收回',
    originalNoWithdrawn: '正本提单未全部收回',
    tian: '天数',
    hcbCode: '航筹办编码',
    cargoGroup: '货种',
    voyageType: '航次类型',
    voyageEndTime1: '航次结束时间',
    voyageStartTime1: '航次开始时间',
    voyageEndTimeFr: '航次结束时间从',
    voyageEndTimeTo: '航次结束时间到',
    portCode: '港口代码',
    //航次测算
    voyageEstimate: '航次测算管理',
    voyageEstimateQuery: '航次测算查询',
    newTimeLeaseBulkCargo: '新建期租测算',
    newRentBulkCargo: '新建程租测算',
    newTransferCharter: '新增转货测算',
    createContract: '生成合同',
    quickCalculation: '快速测算',
    portfolioCalculation: '组合测算',
    fleet: '船队',
    voyageSeq: '航次',
    isHistory: '结算版本',
    vesselType: '船舶类型',
    estimateNo: '测算编号',
    estimateType: '测算类型',
    estimateDate: '测算时间',
    estimator: '测算人',
    relationCp: '是否关联合同',
    hireCost: '日租金',
    freightRate: '单价或包干费',
    freightTotalIncome: '收入',
    freightTotalExpense: '支出',
    profit: '利润',
    averageDailyProfit: '日均利润',
    item: '项目',
    actualDays: '实际天数',
    roundDays: 'ROUND天数',
    roundAmount: 'ROUND金额',
    rentBulkCargoDetail: '程租测算明细',
    timeLeaseCargoDetail: '期租测算明细',
    measuredShipInfomation: '测算船舶信息',
    palletInformation: '货盘信息',
    timeLeaseRentInformation: '期租租金信息',
    ballastInformation: '空放信息',
    hangingInformation: '挂港信息',
    ballastVoyageTimeConsume: '空放航次耗时',
    ballastVoyageFuelConsume: '空放耗油',
    voyageTimeConsumption: '航次耗时',
    beginTime: '开始时间',
    endTime: '结束时间',
    voyageFuelConsumption: '航次耗油',
    energyEfficiencyInformation: '能效信息',
    calculationResult: '测算结果',
    otherExpense: '其他费用',
    leaseInRent: '租金成本(租入船)',
    vessel: '测算船舶',
    vesselFrom: '船舶来源',
    voyageStartTime: '航次开始',
    voyageEndTime: '航次结束',
    currency: '币种',
    addFromPallet: '从货盘中添加',
    cargoType: '分类',
    palletName: '货盘名称',
    cargoName: '货物名称',
    billVolume: '计费量',
    quantityUnit: '计费单位',
    unitPrice: '运价',
    freight: '运费收入',
    dailyHire: '日租金',
    addComm: '租家回佣',
    totalAddComm: '佣金收入',
    brokerage: '经纪人佣金',
    palletNo: '货盘编号',
    idlerDays: '空载航行天',
    ladenSeaDays: '重载航行天',
    loadDays: '在港装天',
    dischargeDays: '在港卸天',
    portNotWorkDays: '非作业天',
    acrossTheCanal: '过运河',
    exportCurrentPage: '导出当前页',
    insertRow: '插入一行',
    portChange: '港口变更',
    acquirePortSpace: '获取港间距',
    voyageTceNet: '航次TCE收入',
    dayTecNet: '日均TCE',
    dayVoyageProfit: '日均航次利润',
    totalFreightIncome: '总运费收入',
    totalRentalIncome: '总租金',
    totalRental: '租金成本',
    BBIncome: '空放津贴',
    BBCost: '空放津贴支出',
    surcharge: '附加费',
    demurrageCharge: '滞期费',
    otherIncome: '其他收入',
    totalIncome: '总收入',
    totalCommission: '佣金支出',
    netIncome: '净收入',
    expenditures: '港口使费',
    fuelExpense: '燃油费用',
    ballastFuelExpense: '空放油耗',
    dayRentCost: '日租金/成本',
    ohterFeeExpense: '其他费用',
    totalExpense: '总支出',
    totalCarbonEmissions: '碳排放总量',
    currentValue: '当前值',
    carbonEmissionCurrent: '年度累积值',
    carbonEmissionCumulative: '预计航次后累积值',
    ciiRank: '预计航次后CII评分',
    ciiRankEst: 'CII评分',
    ciiLevel: 'CII评级',
    accumValue: '累计值',
    voyageEmissions: '预计本航次排放',
    estimateValue: '测算值',
    expenseAndReceipts: '收支',
    expenseType: '费用类型',
    expenseAmount: '费用金额',
    hireDay: '租金天',
    hire: '租金',
    destination: '抵港目的',
    portDistance: '航行里程',
    lowSulfurArea: '低硫区',
    isLowSulfurArea: '低硫区港',
    seaMargin: '天气因素',
    seaDays: '航行天',
    lowSulfurAreaDay: '低硫区天',
    portExpense: '港口使费',
    breakevenCost: '租金成本(自有船)',
    breakevenFee: '保本费用',
    breakevenDays: '保本天数',
    ballastSpeed: '项目(航速)',
    emptyVoyage: '空载航行',
    fullVoyage: '满载航行',
    noOperatorPort: '在港非作业',
    unloadOperatorPort: '在港作业卸货',
    loadOperatorPort: '在港作业装货',
    shipUnLoadOperatorPort: '在港作业卸货(船吊)',
    shipLoadOperatorPort: '在港作业装货(船吊)',
    dailyFuelConsumption: '船规日均航速油耗',
    actualFuelConsumption: '航段油耗小计',
    roundFuelConsumption: 'ROUND油耗',
    HSFO: '高硫重油',
    LSFO: '低硫重油',
    HSMGO: '高硫轻油',
    LSMGO: '低硫轻油',
    ballastDays: '空放航行天',
    rentDays: '期租天数',
    voyageDays: '航行天数',
    workDays: '装卸天',
    lodDisFee: '装卸货费',
    liftingFee: '吊费',
    bindingFee: '绑扎费',
    rulingFee: '打尺费',
    isShipCarne: '是否船吊',
    hireMessage: '请添加租期租金信息',
    hireInMessage: '请添加租入租金信息',
    selectVesselFirst: '请先选择测算船舶',
    notMatchSpeedInfo: '未匹配到对应航速耗油信息，请先配置',
    notMatchDistanceInFO: '未匹配到对应港对里程，可到对应模块进行配置',
    distanceGetError: '获取港间距失败，请稍后再试',
    cargoMessage: '请添加货盘信息',
    deadweight: '载重吨',
    startPort: '起始港口',
    palletsStatus: '货盘状态',
    loadPort: '装港港口',
    disPort: '卸港港口',
    descriptionMessage: '请填写说明项',
    addFromContract: '从合同中添加',
    importTimeContract: '导入期租合同',
    generateTimeContract: '生成期租合同',
    ballastSubsidy: '空放津贴',
    sweepFee: '还船扫舱费',
    isBtb: '是否背靠背',
    btbDescription: '说明项',
    tradeType: '内外贸',
    cargoClass: '货类',
    serialNumber: '编号',
    chartererNameDetail: '租家信息总览',
    contractOverView: '合同信息总览',
    portInit: '装卸港初始化',
    totalSoliciteAmount: '揽货总运费（收入）',
    totalSaleAmount: '甩货总运费（支出）',
    totalSoliciteCommission: '揽货佣金',
    totalSaleCommission: '甩货佣金',
    totalCommissionAmount: '总佣金',
    transferEstimateDetail: '转货测算明细',
    newSettleTimeLeaseBulkCargo: '新建期租询盘',
    newSettleRentBulkCargo: '新建程租询盘',
    newSettleTransferCharter: '新增转货询盘',
    addEstimate: '新增询盘测算',
    addSettlement: '新增测算',
    businessType: '业务类型',
    businessKind: '业务分类',
    enquiryEstimate: '生成测算',
    amongSulfurDay: '其中低硫区天',
    tceBalance: 'TCE收入',
    companyName: '经营公司',
    freightType: '运费类型',
    bunkerPriceCheck: '油价计算',
    freightOtherIncome: '运费其他收入',
    demurrageCharges: '滞期费',
    dispatchCharges: '速遣费',
    isOverload: '是否重载',
    expectStartTime: '预计航次开始时间',
    backToBackAdd: '新增背靠背',
    cargoAmount: '货物费用',
    totalFreightExpense: '运费成本',
    executeVoyageNo: '执行航次号',
    executeVoyageStatus: '执行航次状态',
    tradingArea: '贸易航线',
    //航次预结算
    voyageBusinessAny: '航次经营分析',
    voyageAdvanceSettle: '航次预结算（月底）',
    voyageAdvanceDetail: '航次预结算（月底）明细',
    estimateIncome: '测算收入',
    budgetIncome: '预算收入',
    estimateExpense: '测算支出',
    budgetExpense: '预算支出',
    estimateTceIncome: '测算TCE收入',
    budgetTceIncome: '预算TCE收入',
    estimateDailyTce: '测算日均TCE',
    budgetDailyTce: '预算日均TCE',
    approvalTime: '审核时间',
    version: '版本号',
    voyageEndAudit: '航次预结束审批',
    completedVoyageTime: '已完成航次耗时',
    completedVoyageFuel: '已完成航次耗油',
    uncompleteVoyageTime: '未完成航次测算耗时',
    uncompleteVoyageFuel: '未完成航次耗油标准',
    timeConsume: '耗时',
    fuelConsume: '耗油',
    onPortDay: '在港天',
    voyageSettlement: '航次结算',
    voyageSettlementDetail: '航次结算明细',
    voyageLanding: '航次挂港',
    voyageIncome: '航次收入',
    voyageExpense: '航次支出',
    voyageBalance: '航次收益',
    businessDays: '运营天',
    removeOffLease: '剔除停租',
    auditFlag: '审核标记',
    reckoner: '结算人',
    balanceDate: '结算日期',
    exportCompare: '导出结算与测算对比',
    //Export Settlement and Calculation Comparison,
    recalculate: '重新计算',
    viewContractDetail: '查看合同摘要',
    viewVoyageTask: '查看航次任务',
    historySettlement: '历史结算',
    exportVloc: '导出VLOC结算',
    voyageEndApproval: '航次结束审批',
    voyageSpeedInfo: '航次定速信息',
    cargoQuantity: '货量',
    workEfficiency: '装卸效率',
    hoursOfTt: 'TT(小时)',
    advanceSettleInfo: '以下预算值基于租船人员的航次测算，结算值基于调度人员的月底结算。',
    compareSettleInfo: '以下预算值基于租船人员的航次测算，实际值基于调度人员的航次结算。',
    importvoyageCalculation: '导入航次测算',
    setTheMainCalculation: '设置为主测算',
    deleteAssociation: '删除航次关联',
    mainCalculation: '主测算',
    //航次结算
    voyageInformation: '航次信息',
    settlementIncome: '结算收入',
    settlementCost: '结算支出',
    settlementTce: '结算TCE收入',
    settlementTceNet: '结算日均TCE',
    //额外
    endPort: '结束港',
    portDistances: '里程数',
    lowSulfurDistance: '低硫距离',
    cancelApprove: '取消审批',
    price: '金额',
    cargoNum: '货量',
    extraCharge: '附加费',
    jumpToNew: '跳转至最新版报告',
    //vloc
    vloc: {
      addVlocEstimate: '新增VLOC暂估测算',
      freshSelectData: '重新载入选中行数据',
      viewVlocFuel: 'VLOC燃油数据',
      vlocEstimate: 'VLOC暂估测算',
      vlocEstimateDetail: 'VLOC暂估测算明细',
      yearMonth: '年月',
      gDayRent: 'G日租金',
      operatingDays: '营运天',
      accumulatedOperatingDays: '累计营运天',
      rentFreight: '租金/运费',
      accumulatedRentFreight: '累计确认租金/运费',
      firstBrokerComm: '经纪人1佣金率',
      firstBrokerCommAmount: '经纪人1佣金',
      detailCount: '生成暂估测算航次数',
      vlocCreateTime: '暂估测算创建时间',
      vlocModifyTime: '暂估测算最后修改时间',
      consumptionQty: '实际消耗数量\n(20号午报)',
      estimateConsumptionQty: '暂估消耗数量\n(午报至月底)',
      averagePrice: '平均油价',
      consumptionAmount: '消耗金额\n(20号午报)',
      estimateAmount: '预估金额\n(午报至月底)',
      amount: '消耗总金额'
    },
    tce: {
      tceEstimate: 'POOL预估收益',
      tceEstimateDetail: 'POOL预估收益明细',
      detailCount: '生成预估收益航次数',
      tceCreateTime: '预估收益创建时间',
      tceModifyTime: '预估收益最后修改时间',
      monthEstiamte: '本月预估',
      preMonthEstimate: '上月预估(参考)',
      totalOperationDays: '总营运天',
      lockOperationDays: '已锁定营运天',
      lockTce: '已锁定TCE',
      lockTceIncome: '已锁定TCE收入',
      unlockOperationDays: '未锁定营运天',
      lockRate: '锁定率（%）',
      lockOrEstimateTce: '锁定TCE/\n预算TCE',
      lockOrEstimateDay: '锁定营运天/\n预算营运天',
      lockDay: '锁定天',
      detailLockTce: '锁定TCE',
      detailLockTceIncome: '锁定TCE收入',
      annualRange: '全年/区间',
      tceLockDetail: 'TCE锁定明细',
      tceLockSummary: 'TCE锁定率',
      tceEstOther: '预估航次收益',
      generateRecalucation: '生成/重新计算'
    },
    budget: {
      budgetManage: '预算管理',
      operationalPlan: '营运计划',
      dayNetTce: '日均净TCE',
      dayGrossTce: '日均毛TCE',
      operationRate: '营运率',
      grossTceIncome: '毛TCE收入',
      estRetireDate: '预计退役时间',
      commissionAmount: '佣金总额',
      totalNetIncome: '总净收入',
      totalGrossIncome: '总毛收入'
    }
  }
};